import { useIntl } from "react-intl";
import LeftMenuBurger from "../components/LeftMenuBurger";
import { useUIState } from "../store/ui/UIState";

function Header() {
  const { formatMessage } = useIntl();
  const { toggleLeftMenu } = useUIState();

  return (
    <header>
      <LeftMenuBurger onClick={toggleLeftMenu} />
      <div className="title">{formatMessage({ id: "common.header" })}</div>
    </header>
  );
}

export default Header;
